import axiosInstance, { getApiUrl, ApiKeys, logError } from '@cp/src/utils/ApiHelper';
import { setCallAttemptLimitAlert } from '../../reducers/caseDetailSlice';
import { Dispatch } from '@reduxjs/toolkit';

export const getCallAttemptLimitAlert =
  (caseBusinessVertical: string, caseReferenceId: string) => async (dispatch: Dispatch) => {
    try {
      const url = getApiUrl(ApiKeys.CALL_ATTEMPT_LIMIT_ALERT, null, {
        caseBusinessVertical,
        caseReferenceId
      });
      const response = await axiosInstance.get(url, { headers: { donotHandleError: true } });

      dispatch(setCallAttemptLimitAlert(response?.data));
    } catch (error) {
      logError(error);
    }
  };
